<script setup lang="ts">
import Logo from '@/assets/logo-v3.svg'
import { useI18n } from 'vue-i18n'
import { logOut } from '@/api/logOut'
import HeaderMenu from './HeaderMenu.vue'
import { useAppMode } from '@/composables/useAppMode'
import { provide } from 'vue'
import BackIcon from '@/assets/icons/interface/back.svg?component'
import { useRouter } from 'vue-router'
import UiButton from '@/components/ui/button/Button.vue'
import ArrowLeft from '@/assets/icons/arrow-left.svg'
import { useFlags } from '@/composables/useFeatureFlags'

const featureFlags = useFlags(['quintace_home_top_right_user_menu'])
const isQuintaceHomeTopRightUserMenuEnabled = featureFlags.isEnabled(
  'quintace_home_top_right_user_menu'
)

const { t } = useI18n()

const { mode } = useAppMode()

const onLogOutClick = () => {
  const isExit = confirm(t('label.AreUSureYouWantToLogout'))
  if (!isExit) return
  logOut()
}

provide('logOut', onLogOutClick)

const props = defineProps({
  showBack: {
    type: Boolean,
    default: false
  }
})

const router = useRouter()

const goBack = () => {
  router.go(-1)
}
</script>

<template>
  <header class="flex w-full items-center justify-between px-2 py-2 desktop:px-[40px]">
    <slot name="logo">
      <div class="flex min-h-[50px] items-center">
        <UiButton
          v-if="props.showBack"
          class="flex items-center space-x-1 border-none bg-transparent"
          @click="goBack"
        >
          <ArrowLeft class="w-5 h-5 [&>path]:fill-custom-gray" />
          <span class="text-sm text-custom-gray">Back</span>
        </UiButton>
        <router-link v-else to="/home" class="flex items-center">
          <Logo class="h-6" />
        </router-link>
      </div>
    </slot>

    <div class="flex items-center">
      <slot name="buttons">
        <HeaderMenu v-if="isQuintaceHomeTopRightUserMenuEnabled" />
      </slot>
    </div>
  </header>
</template>
